import React from "react";
import "./add-space-section-feature-theme2.scss";
const AdsSpaceSectionTheme2 = ({ adsDetails }) => {
  return (
    <div>
      {adsDetails &&
      adsDetails.campagin_data &&
      adsDetails.campagin_data.campaign_banner_img ? (
        <div className="ads-space-section-seller">
          <img
            src={adsDetails.campagin_data.campaign_banner_img}
            alt="banner"
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
export default AdsSpaceSectionTheme2;
